(() => {
  if (customElements.get('emberly-color-collection')) return;
  customElements.define('emberly-color-collection', class extends HTMLElement {
    connectedCallback() {
      // Facets replaces this element, then synchronously restores the native model count.
      // Run once after that render; no document observers or stale card references.
      queueMicrotask(() => {
        if (!this.isConnected) return;
        const grid = this.querySelector('#product-grid');
        if (!grid) return;
        const cards = [...grid.children].filter(card => card.hasAttribute('data-em-model'));
        const direction = this.dataset.sort === 'price-ascending' ? 1 : this.dataset.sort === 'price-descending' ? -1 : 0;
        if (direction) {
          cards.sort((a, b) => direction * (Number(a.dataset.emCardPrice) - Number(b.dataset.emCardPrice)));
          grid.append(...cards);
        } else if (['manual', 'most-relevant'].includes(this.dataset.sort)) {
          // Featured presentation only. Explicit customer price/date/title sorts stay native.
          // Delivery numbers are estimates; available is Shopify availability, not CJ stock proof.
          cards.sort((a, b) => {
            const availability = Number(b.dataset.emAvailable === 'true') - Number(a.dataset.emAvailable === 'true');
            if (availability) return availability;
            const priority = Number(a.dataset.emFeaturedPriority ?? 10) - Number(b.dataset.emFeaturedPriority ?? 10);
            if (priority) return priority;
            const aWindow = Number(a.dataset.emDeliveryMax) || 999;
            const bWindow = Number(b.dataset.emDeliveryMax) || 999;
            return aWindow - bWindow;
          });
          grid.append(...cards);
        }
        const models = new Set(cards.map(card => card.dataset.emModel)).size;
        const pageText = Number(this.dataset.pages) > 1 ? ' on this page' : '';
        const count = `${models} ${models === 1 ? 'model' : 'models'} · ${cards.length} ${cards.length === 1 ? 'finish' : 'finishes'}${pageText}`;
        const note = this.querySelector('[data-em-color-count]');
        if (note) note.textContent = 'Choose your finish.';
        this.closest('collection-component')?.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(element => { element.textContent = count; });
      });
    }
  });
})();
